var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { property, listing_index, newLabel } = options; 
__p+='\n<li class="component_property-card js-component_property-card js-quick-view" data-listingid="'+
((__t=( property.listing_id ))==null?'':__t)+
'" data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'" data-url="'+
((__t=( property.ldp_url ))==null?'':__t)+
'" data-featured="" data-rank="'+
((__t=( listing_index + 1 ))==null?'':__t)+
'" id="'+
((__t=( listing_index + 1 ))==null?'':__t)+
'" itemscope="" itemtype="http://schema.org/SingleFamilyResidence" add-lead-form-modal="">\n  <div class="seo-wrap hide">\n    <span itemprop="address" itemscope="" itemtype="http://schema.org/PostalAddress">\n    <span itemprop="streetAddress">'+
((__t=( property.address ))==null?'':__t)+
'</span>\n    <span itemprop="addressLocality">'+
((__t=( property.city ))==null?'':__t)+
'</span>\n    <span itemprop="addressRegion">'+
((__t=( property.state_code ))==null?'':__t)+
'</span>\n    <span itemprop="postalCode">'+
((__t=( property.postal_code ))==null?'':__t)+
'</span>\n    </span>\n    <span class="listing-geo" itemprop="geo" itemscope="" itemtype="http://schema.org/GeoCoordinates">\n      <meta content="'+
((__t=( property.lat ))==null?'':__t)+
'" itemprop="latitude">\n      <meta content="'+
((__t=( property.long ))==null?'':__t)+
'" itemprop="longitude">\n    </span>\n  </div>\n  <div class="pre-card-wrap">\n    <div class="broker-info">\n      <div class="ellipsis" id ="notify-ellipsis">\n        <span>Brokered by </span>\n        <span data-label="property-broker">'+
((__t=( property.office_name ))==null?'':__t)+
'</span>\n      </div>\n    </div>\n    ';
 // Wrapping everything in one line since ejs is producing non empty blank strings 
__p+='\n    ';
 if(property && property.search_flags) { 
__p+='<div class="label-wrap">';
 if(property.search_flags.is_new_listing) { 
__p+='<span class="label c_label label-green" data-label="property-label-new">'+
((__t=( newLabel ))==null?'':__t)+
'</span>';
 } 
__p+='';
 if(property.search_flags.is_pending) { 
__p+='<span class="label c_label label-red" data-label="property-label-pending">Pending</span>';
 } 
__p+='';
 if(property.search_flags.is_contingent) { 
__p+='<span class="label c_label label-red" data-label="property-label-pending">Contingent</span>';
 } 
__p+='';
 if(property.search_flags.is_foreclosure) { 
__p+='<span class="label c_label label-gray color-base" data-label="property-label-new">Foreclosure</span>';
 } 
__p+='';
 if(property.search_flags.is_featured) { 
__p+='<span class="label c_label label-gray-darker" data-label="property-label-new">Featured</span>';
 } 
__p+='';
 if(property.open_house_display) { 
__p+='<span itemscope itemtype="http://schema.org/Event" class="label c_label label-dark-transparent label-outline-none" data-label="property-label-open-house"><span itemprop="name" data-label="property-openhouse">Open House '+
((__t=( property.open_house_display ))==null?'':__t)+
'</span></span>';
 } 
__p+='</div>';
 } 
__p+='\n  </div>\n  <div class="card-box js-navigate-to js-record-user-activity" id="'+
((__t=( property.property_id ))==null?'':__t)+
'" data-remnant="" data-featured-token="" data-url="'+
((__t=( property.ldp_url ))==null?'':__t)+
'">\n    <div class="photo-wrap " data-label="property-photo">\n      <a href="'+
((__t=( property.ldp_url ))==null?'':__t)+
'">\n      <img alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'" class="js-srp-listing-photos main-photo" itemprop="image" data-src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" data-omtag="for_sale:srp_list:card:result_photo" data-alternatephoto="'+
((__t=( property.alternate_photo_url ))==null?'':__t)+
'" src="'+
((__t=( property.photo_url ))==null?'':__t)+
'">\n      </a>\n      <div class="photo-wrap-detail-overlay"></div>\n    </div>\n    <div class="detail-wrap ">\n      <div class="photo-overlay">\n        <div class="property-type">'+
((__t=( property.type_display ))==null?'':__t)+
'</div>\n      </div>\n      <div class="photo-overlay-right"></div>\n      <div class="price" data-label="property-price">\n        <div itemscope="" itemtype="http://schema.org/Product">\n          <link itemprop="additionalType" href="http://www.productontology.org/id/Real_estate">\n          <meta itemprop="image" content="'+
((__t=( property.photo_url ))==null?'':__t)+
'">\n          <meta itemprop="name" content="'+
((__t=( property.full_address_display ))==null?'':__t)+
'">\n          <meta itemprop="productID" content="'+
((__t=( property.property_id ))==null?'':__t)+
'">\n          <meta itemprop="brand" content="realtor.com">\n          <meta itemprop="manufacturer" content="'+
((__t=( property.office_name ))==null?'':__t)+
'">\n          <meta itemprop="description" content="'+
((__t=( property.type_display ))==null?'':__t)+
' - '+
((__t=( property.full_address_display ))==null?'':__t)+
'">\n          <div itemprop="offers" itemscope="" itemtype="http://schema.org/Offer">\n            <meta itemprop="priceCurrency" content="USD">\n            <meta itemprop="price" content="'+
((__t=( property.price ))==null?'':__t)+
'">\n            <link itemprop="businessFunction" href="http://purl.org/goodrelations/v1#Sell">\n            <meta itemprop="category" content="Real Estate > '+
((__t=( property.type_display ))==null?'':__t)+
'">\n          </div>\n        </div>\n        <span class="data-price">'+
((__t=( property.price_display ))==null?'':__t)+
'</span>\n      </div>\n      <ul class="prop-meta ellipsis">\n        ';
 if(property.beds){ 
__p+='\n          <li data-label="property-meta-beds"><span class="data-value meta-beds">'+
((__t=( property.beds ))==null?'':__t)+
'</span> bed</li>\n        ';
 } 
__p+='\n        ';
 if(property.baths){ 
__p+='\n          <li data-label="property-meta-baths"><span class="data-value">'+
((__t=( property.baths ))==null?'':__t)+
'</span> bath</li>\n        ';
 } 
__p+='\n        ';
 if(property.sqft_display){ 
__p+='\n          <li data-label="property-meta-sqft"><span class="data-value">'+
((__t=( property.sqft_display ))==null?'':__t)+
'</span> sqft</li>\n        ';
 } 
__p+='\n        ';
 if(property.lot_size_display){ 
__p+='\n          <li data-label="property-meta-lotsize"><span class="data-value">'+
((__t=( property.lot_size_display ))==null?'':__t)+
'</span><span class="lot-label"> sqft lot</span></li>\n        ';
 } 
__p+='\n        ';
 if(property.garage){ 
__p+='\n          <li data-label="property-meta-garage"><span class="data-value">'+
((__t=( property.garage ))==null?'':__t)+
'</span> car</li>\n        ';
 } 
__p+='\n      </ul>\n      <div class="address" data-label="property-address">\n        <a href="'+
((__t=( property.ldp_url ))==null?'':__t)+
'">\n          <span class="listing-street-address">'+
((__t=( property.address ))==null?'':__t)+
'</span><br>\n          <span class="listing-city">'+
((__t=( property.city ))==null?'':__t)+
'</span>,\n          <span class="listing-region">'+
((__t=( property.state_code ))==null?'':__t)+
'</span>\n          <span class="listing-postal">'+
((__t=( property.postal_code ))==null?'':__t)+
'</span>\n        </a>\n      </div>\n    </div>\n    <div class="save-wrap" data-listingid="'+
((__t=( property.listing_id ))==null?'':__t)+
'" data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'" data-status="'+
((__t=( property.status ))==null?'':__t)+
'">\n      ';
 if ($.cookie('REMEMBER_ME')) { 
__p+='\n        <a class="js-delete-listing btn-save-listing js-save-trigger" style="display:'+
((__t=( property.saved_resource_id ? 'block' : 'none' ))==null?'':__t)+
'" data-res-id="'+
((__t=( property.saved_resource_id ))==null?'':__t)+
'">\n          <span class="ra-stack icon-save-lg">\n            <i class="ra ra-heart icon-save ra-stack-2x js-no-listing-click"></i>\n            <i class="ra ra-heart-o ra-stack-1x js-no-listing-click"></i>\n          </span>\n        </a>\n        <a class="js-save-listing btn-save-listing js-save-trigger" style="display:'+
((__t=( property.saved_resource_id ? 'none' : 'block' ))==null?'':__t)+
'" data-omtag="'+
((__t=( `${property.status}:${MOVE_DATA.adobeDTM.pageType}:notifications_modal:listing_save` ))==null?'':__t)+
'">\n          <span class="ra-stack icon-save-lg">\n            <i class="ra ra-heart ra-stack-1x js-no-listing-click" data-omtag="'+
((__t=( `${property.status}:${MOVE_DATA.adobeDTM.pageType}:notifications_modal:listing_save` ))==null?'':__t)+
'"></i>\n            <i class="ra ra-heart-o ra-stack-2x js-no-listing-click" data-omtag="'+
((__t=( `${property.status}:${MOVE_DATA.adobeDTM.pageType}:notifications_modal:listing_save` ))==null?'':__t)+
'"></i>\n          </span>\n        </a>\n      ';
 } else { 
__p+='\n        <a href="" class="btn-save-listing srp-save-not-logged-in js-save-trigger">\n          <span class="ra-stack icon-save-lg">\n            <i class="ra ra-heart ra-stack-1x js-no-listing-click" data-omtag="'+
((__t=( `${property.status}:${MOVE_DATA.adobeDTM.pageType}:notifications_modal:listing_save` ))==null?'':__t)+
'"></i>\n            <i class="ra ra-heart-o ra-stack-2x js-no-listing-click" data-omtag="'+
((__t=( `${property.status}:${MOVE_DATA.adobeDTM.pageType}:notifications_modal:listing_save` ))==null?'':__t)+
'"></i>\n          </span>\n        </a>\n      ';
 } 
__p+='\n    </div>\n  </div>\n  <div class="cta-wrap">\n    <a href="javascript:void(0);" class="btn btn-primary cta-btn before-contact js-no-listing-click" data-toggle="modal" data-target="#srp-lead-modal[listing-id=\''+
((__t=( property.listing_id ))==null?'':__t)+
'\']" data-omtag="'+
((__t=( `for_sale:${MOVE_DATA.adobeDTM.pageType}:notifications_modal:contact_agent` ))==null?'':__t)+
'">\n    Contact Agent</a>\n    <a href="javascript:void(0);" class="cta-btn after-contact">\n    Contacted</a>\n  </div>\n  <div class="data-wrap"\n    id="'+
((__t=( listing_index + 1 ))==null?'':__t)+
'"\n    data-advertiserid-agent="'+
((__t=( property.agent_advertiser_id ))==null?'':__t)+
'"\n    data-advertiserid-office="'+
((__t=( property.office_advertiser_id ))==null?'':__t)+
'"\n    data-advertiserid-broker="'+
((__t=( property.broker_advertiser_id ))==null?'':__t)+
'"\n    data-listingid="'+
((__t=( property.listing_id ))==null?'':__t)+
'"\n    data-omtag="srp-listMap:result:link"\n    data-page="SRPLIST"\n    data-producttype="'+
((__t=( property.product_type ))==null?'':__t)+
'"\n    data-type="'+
((__t=( property.type_display ))==null?'':__t)+
'"\n    data-proptype="M"\n    data-propertytype="'+
((__t=( property.type ))==null?'':__t)+
'"\n    data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'"\n    data-status="for_sale" data-url="'+
((__t=( property.ldp_url ))==null?'':__t)+
'"\n    data-search_flags='+
((__t=( JSON.stringify(property.search_flags) ))==null?'':__t)+
'\n    data-price="'+
((__t=( property.price ))==null?'':__t)+
'"\n    data-product_name="'+
((__t=( property.product_name ))==null?'':__t)+
'"\n    data-baths_full="'+
((__t=( property.baths_full))==null?'':__t)+
'"\n    data-baths_half="'+
((__t=( property.baths_half ))==null?'':__t)+
'"\n    data-baths="'+
((__t=( property.baths ))==null?'':__t)+
'"\n    data-lot_size="'+
((__t=( property.lot_size_display ))==null?'':__t)+
'"\n    data-lead_attributes='+
((__t=( JSON.stringify(property.lead_attributes) ))==null?'':__t)+
'\n    add-lead-form-modal=""\n    data-display_tcpa_message="'+
((__t=( property.search_flags.is_tcpa_message_enabled ))==null?'':__t)+
'"\n    data-gallery-photos="">\n  </div>\n</li>';
return __p;
};



// WEBPACK FOOTER //
// ./srp/basecamp/templates/optimizely/smart_notification/notification-srp-card.jst.ejs